import React from 'react';
import PricePlanCard from '../priceplan-page/PricePlanCard';

const PlanPackage = ({ scrollToBooking }) => {
  return (
    <PricePlanCard
      buttonLabel="Let's Connect"
      onPlanSelect={scrollToBooking}
      rowClassName='ppc-row--sales-booking'
    />
  );
};

export default PlanPackage;
